import React, {useState} from "react";
import CvEditByte from "./CvEditByte";
import CvEditSelect from "./CvEditSelect";
import CvEditMatrix from "./CvEditMatrix";
import CvEditCvGroup from "./CvEditCvGroup";
import CvEditLong from "./CvEditLong";

export const TYPE_BYTE = "byte"
export const TYPE_SELECT = "select"
export const TYPE_LIST = "list"
export const TYPE_CURVE = "dccSpeedCurve"

export const TYPE_INT = "int"
export const TYPE_LONG = "long"
export const TYPE_STR = "string"

export const TYPE_MATRIX = "matrix"

const CvEdit = ({data, activeItems}) => {
    const {type} = data;


    let editor = <div key={data?.id}>##not yet implemented: {type}##</div>

    function onChange(val) {
        console.log("CvEdit::onChange", val)
    }

    if( type === TYPE_BYTE ){
        editor = <CvEditByte data={data} onChange={onChange}/>
    } else if( type === TYPE_SELECT ){
        editor = <CvEditSelect data={data} onChange={onChange} activeItems={activeItems}/>
    } else if( type === TYPE_MATRIX ){
        //editor = <CvEditMatrix data={data} onChange={onChange} activeItems={activeItems}/>
    } else if( type === TYPE_LIST ){
        //editor = <CvEditCvGroup data={data} onChange={onChange}/>
    }  else if( type === TYPE_CURVE ){
        //editor = "|CURVE|"
    } else if( type === TYPE_STR ){
        //editor = "|STR|"
    } else if( type === TYPE_INT ){
        //editor = <CvEditLong data={data} onChange={onChange}/>
    } else if( type === TYPE_LONG ){
        //editor = <CvEditLong data={data} onChange={onChange}/>
    }

    const containerstyle = {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'right',
        backgroundColor: '#a7bed3',
        color: '#223322',
        margin: '10px',
    }

    return(
        <div style={containerstyle}>
            {editor}
        </div>
    )
}

export default CvEdit;